import { Submission } from '../../types';
import { getApiBaseUrl } from '../../utils/api-base-url';

export const postSubmission = async (
  urlSlug: string,
  responses: Record<string, unknown>,
  captchaToken: string,
  metadataToken?: string,
): Promise<Submission> => {
  const response = await fetch(`${getApiBaseUrl()}/submissions/${urlSlug}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      responses,
      captchaToken,
      metadataToken,
    }),
  });
  const submission = await response.json();
  return submission.data;
};
